export default __webpack_public_path__ + "static/media/LAS1000.34I-43771_-26130_0.f5548fc4.jpg";